// extracted by mini-css-extract-plugin
module.exports = {"stack":"page_stack__i5A6Q","root":"page_root__Kp3Kw","text":"page_text__wJ4Uh"};